export const ANALYTICS_EVENTS = {
  FEATURE_ENGAGED: "Feature Engaged",
} as const;

export type AnalyticsEvent = typeof ANALYTICS_EVENTS[keyof typeof ANALYTICS_EVENTS];

export const ANALYTICS_LOCATIONS = {
  SIDE_NAVIGATION: "Billing Portal Side Navigation",
  SUBSCRIPTIONS_LIST: "Billing Portal Subscriptions List",
  TRANSACTIONS_LIST: "Billing Portal Transactions List",
  PAYMENT_METHODS: "Billing Portal Payment Methods",
} as const;

export type AnalyticsLocation = typeof ANALYTICS_LOCATIONS[keyof typeof ANALYTICS_LOCATIONS];

export interface TrackEventProperties {
  feature: string;
  location: AnalyticsLocation;
  details?: string;
  // Using snake_case to match internal Segment naming conventions
  user_type?: number;
  [key: string]: unknown;
}

export interface IdentifyTraits {
  email?: string;
  firstName?: string;
  lastName?: string;
  // Using snake_case to match internal Segment naming conventions
  user_type?: number;
  [key: string]: unknown;
}
